<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="编辑项目"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="850px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="项目名称：" prop="projectName">
          <el-input size="mini" v-model.trim="form.projectName" placeholder="请输入项目名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" class="mr0">
          <el-input
            size="mini"
            v-number-only:11
            v-model.trim="form.contactTelephone"
            placeholder="请输入联系电话"
            clearable
          ></el-input>
        </el-form-item>
        <AddreassSelect :warning="addressWarn" :initData="defaultAddress"  class="input-with-col2" @change="setPojectAddress"></AddreassSelect>

        <el-form-item label="使用单位：" prop="propertyUnitId">
          <el-select
            size="mini"
            v-model="propertyObj"
            filterable
            placeholder="请选择使用单位"
            clearable
            reserve-keyword
            :remote="true"
            @change="chooseProperty"
            :remote-method="searchUnitList"
            @visible-change="searchUnitList('')"
            value-key="id"
          >
            <el-option
              v-for="item in unitList"
              :key="item.id"
              :label="item.unitName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门：" class="mr0" prop="departmentIdList">
          <el-select
            size="mini"
            v-model="form.departmentIdList"
            filterable
            multiple
            collapse-tags
            placeholder="请选择所属部门"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchDepartmentList"
            @visible-change="searchDepartmentList('')"
            value-key="id"
          >
            <el-option
              v-for="item in departmentList"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
      >确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addProject, getDepartmentList, getUnitSimpleList, getProjectDetail } from "@/api/ProjectManagement";
import AddreassSelect from "../../../components/AddreassSelect/AddreassSelect";

export default {
  data() {
    return {
      form: {
        contactTelephone: "",
        address: "",
        cityCode: "",
        projectName: "",
        districtCode: "",
        provinceCode: "",
        propertyUnitId: "",
        departmentIdList: []
      },
      addressWarn: false,
      videoStatusList: [
        {code: 10,  name: '不强制'},
        {code: 20,  name: '强制'},
      ],
      rules: {
        projectName: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        propertyUnitId: [
          {
            required: true,
            message: "请选择使用单位",
            trigger: "change",
          },
        ],
        departmentIdList: [
          {
            required: true,
            message: "请选择所属部门",
            trigger: "change",
          },
        ],
      },
      loadBtn: false,
      unitList: [],
      departmentList: [],
      propertyObj: {},
      departmentObj: {},
      defaultAddress: {}
    };
  },
  components: {
    AddreassSelect,
  },
  props: ['editData'],

  created() {
    this.form = { ...this.editData }
    this.propertyObj = {
      id: this.form.propertyUnitId,
      unitName: this.form.propertyUnitName
    }
    this.searchUnitList();
    this.searchDepartmentList();
    this.getProjectDetail()
  },
  mounted() {
    this.$nextTick(() => {
      this.defaultAddress = {
        addressData: this.form.address,
        provinceCode: this.form.provinceCode,
        provinceName: this.form.provinceName,
        cityCode: this.form.cityCode,
        cityName: this.form.cityName,
        townCode: this.form.districtCode,
        townName: this.form.districtName,
      };
      
    })
  },
  methods: {
    async getProjectDetail() {
      const res = await getProjectDetail({ projectId: this.editData.id });
      if (res.code === 200) {
        this.form = {...res.data}
        console.log(res.data)
        this.propertyObj = {
          id: res.data.propertyUnitId

        }
        let arr = []
        if (res.data.departmentInfo && res.data.departmentInfo.length){
          arr = res.data.departmentInfo.map(item => item.departmentId)
        } else {
          arr = []
        }
        this.$set(this.form, 'departmentIdList', arr)
      }
    },
    async searchDepartmentList(keyword) {
      const res = await getDepartmentList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.departmentList = res.data;
      }
    },
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const res = await addProject(this.form);
          if (res.code === 200) {
            this.$message.success("添加成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
    setPojectAddress(data) {
      this.form.address = data.addressData; // 项目地址 详细地址
      this.form.provinceCode = data.provinceCode; // 项目地址省级 code
      this.form.provinceName = data.provinceName; // 项目地址省级 name
      this.form.cityCode = data.cityCode; // 项目地址城市 code
      this.form.cityName = data.cityName; // 项目地址城市 name
      this.form.districtCode = data.townCode; // 项目地址区级 code
      this.form.districtName = data.townName; // 项目地址区级 name
    },
    chooseProperty(data) {
      if (data && data.id) {
        this.form.propertyUnitId = data.id
        this.form.propertyUnitName = data.unitName
      } else {
        this.form.propertyUnitId = ''
        this.form.propertyUnitName = ''
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/ProjectManagement/components/EditProject.vue